import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import BadgePrinting from 'views/admin/Badges'
import ConfigurationListing from 'views/admin/Badges/Configurations/ConfigurationListing'

const Badges = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <BadgePrinting />
      </Route>
      <Route path={`${path}/configuration`}>
        <ConfigurationListing />
      </Route>
    </Switch>
  )
}

export default Badges
